// Registro central de temas (Temas 2.0). Substitui THEME_CONFIGS/buildTheme
// de context/DarkMode/index.js — mesmos valores, arquivos próprios por tema.
import { createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { KR, scrollbar } from "./palettes/shared";
import { normalizeCustom } from "./tokens";
import light from "./palettes/light";
import dark from "./palettes/dark";
import highContrast from "./palettes/highContrast";
import corporate from "./palettes/corporate";
import oceano from "./palettes/oceano";
import floresta from "./palettes/floresta";
import sakura from "./palettes/sakura";
import synthwave from "./palettes/synthwave";
import cafe from "./palettes/cafe";
import candy from "./palettes/candy";
import gatinhos from "./palettes/gatinhos";
import galaxia from "./palettes/galaxia";

const REGISTRY = {
  light,
  dark,
  "high-contrast": highContrast,
  corporate,
  oceano,
  floresta,
  sakura,
  synthwave,
  cafe,
  candy,
  gatinhos,
  galaxia,
};

export { KR };
export const isValidTheme = (id) => Boolean(REGISTRY[id]);

export const THEME_OPTIONS = [
  { id: "light",         label: "Claro",          group: "basicos", emoji: "☀️", swatch: "#F1F5F9", border: "#CBD5E1" },
  { id: "dark",          label: "Escuro",         group: "basicos", emoji: "🌙", swatch: "#161B22", border: "#30363D" },
  { id: "high-contrast", label: "Alto Contraste", group: "basicos", emoji: "🔲", swatch: "#000000", border: "#FFD700" },
  { id: "corporate",     label: "Corporativo",    group: "basicos", emoji: "💼", swatch: "#273A74", border: "#0071BC" },
  { id: "oceano",    label: "Oceano",    group: "naturezas", emoji: "🌊", swatch: "#EFF9FB", border: "#0E7490" },
  { id: "floresta",  label: "Floresta",  group: "naturezas", emoji: "🌿", swatch: "#F3F7EF", border: "#2E7D32" },
  { id: "sakura",    label: "Sakura",    group: "naturezas", emoji: "🌸", swatch: "#FFF4F7", border: "#EC6A9F" },
  { id: "synthwave", label: "Synthwave", group: "vibes",     emoji: "🕹️", swatch: "#180438", border: "#FF3CAC" },
  { id: "cafe",      label: "Café",      group: "vibes",     emoji: "☕", swatch: "#F7F1E8", border: "#6D4C41" },
  { id: "candy",     label: "Candy",     group: "vibes",     emoji: "🍬", swatch: "#FFF6FB", border: "#FF5DA2" },
  { id: "gatinhos", label: "Gatinhos", group: "especiais", emoji: "🐱", swatch: "#FDF2F6", border: "#E5679E" },
  { id: "galaxia",  label: "Galáxia",  group: "especiais", emoji: "🌌", swatch: "#0B0E23", border: "#9D7BFF" },
];

export const buildTheme = (themeId) => {
  const cfg = REGISTRY[themeId] || REGISTRY.light;
  const custom = normalizeCustom(cfg);
  const headingFamily = custom.headingFont
    ? `'${custom.headingFont}', 'Inter', 'Roboto', sans-serif`
    : undefined;
  return createTheme(
    {
      themeId: REGISTRY[themeId] ? themeId : "light",
      krColors: KR,
      custom,
      scrollbarStyles: scrollbar(cfg.scrollbarColor),
      palette: { mode: cfg.muiMode, ...cfg.palette },
      typography: {
        fontFamily: "'Inter', 'Roboto', sans-serif",
        h5: { fontWeight: 600, letterSpacing: "-0.01em" },
        h6: { fontWeight: 600, fontSize: "0.9375rem", letterSpacing: "-0.01em" },
        subtitle1: { fontWeight: 500, fontSize: "0.875rem" },
        subtitle2: { fontWeight: 500, fontSize: "0.8125rem", letterSpacing: "0.01em" },
        body1: { fontSize: "0.875rem" },
        body2: { fontSize: "0.8125rem" },
        caption: {
          fontSize: "0.6875rem",
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
          letterSpacing: "0.02em",
        },
        overline: {
          fontSize: "0.6875rem",
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        },
        ...(headingFamily && {
          h5: { fontWeight: 600, letterSpacing: "-0.01em", fontFamily: headingFamily },
          h6: { fontWeight: 600, fontSize: "0.9375rem", letterSpacing: "-0.01em", fontFamily: headingFamily },
        }),
      },
      shape: { borderRadius: 8 },
      components: cfg.components,
    },
    ptBR
  );
};
